import { useMemo } from "react"

import { ReportingBarChart } from "@/components/reporting/charts"
import { formatWeekLabel, formatWeekRangeLabel } from "./week-label"

interface AnalyticsChartProps {
	title: string
	description?: string
	data?: Array<{ bucket: string; count: number }>
	isLoading?: boolean
}

export function AnalyticsChart({
	title,
	description,
	data,
	isLoading,
}: AnalyticsChartProps) {
	const chartData = useMemo(
		() =>
			(data ?? []).map((item) => ({
				date: formatWeekLabel(item.bucket),
				rangeLabel: formatWeekRangeLabel(item.bucket),
				count: item.count,
			})),
		[data],
	)

	return (
		<ReportingBarChart
			title={title}
			description={description}
			data={chartData}
			series={[{ key: "count", label: "Count", tone: "primary" }]}
			isLoading={isLoading}
		/>
	)
}
